import Vue from "Vue";
import searchControlInstance from "Shared/searchControlInstance";

export default class SearchControl {
	constructor() {
		this._initializeVueInstance();
	}

	_initializeVueInstance() {
		this._searchControlInstance = new Vue({
			...searchControlInstance()
		});
	}
}